module.exports = __webpack_public_path__ + "img/ic_contacts.7aa44a3f.svg";